import React, { useState } from 'react';
import Title from '@/components/title';
import { getPathSegment } from '@/utils/pathUtils';
import SubMenu from '@/components/menu/sub-menu';
import { InboundMenu } from '@/configs/menuItems';
import Card from '@/components/card';
import GoodReceiveTable from './components/good-receive-table';
import {
  IGoodReceive,
  ISearchGoodReceiveReq,
  ISearchGoodReceiveRes,
} from '@/interfaces/goodReceive';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { searchGoodReceives } from '@/adapters/goodReceive';
import { DatePicker, TablePaginationConfig } from 'antd';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import Search from 'antd/es/input/Search';
import locale from 'antd/es/date-picker/locale/th_TH';
import { Dayjs } from 'dayjs';

const _criteria: ISearchGoodReceiveReq = {
  pageSize: 10,
  pageStart: 1,
};

const GoodReceived: React.FC = () => {
  const pathSegment = getPathSegment();
  const [criteria, setCriteria] = useState<ISearchGoodReceiveReq>({
    ..._criteria,
  });

  const { data, refetch, isLoading, isFetching } = useQuery<
    AxiosResponse<ISearchGoodReceiveRes>,
    Error
  >({
    queryKey: ['search-goodReceive', criteria],
    queryFn: async () => await searchGoodReceives(criteria),
  });

  const onActionInbound = () => {
    refetch();
  };

  const onTableChange = (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<IGoodReceive> | SorterResult<IGoodReceive>[],
  ) => {
    const newCriteria = { ...criteria };
    if (!Array.isArray(sorter)) {
      newCriteria.orderBy =
        (sorter.column?.dataIndex as keyof IGoodReceive) || newCriteria.orderBy;
      newCriteria.orderType = sorter.order || newCriteria.orderType;
    }
    setCriteria({
      ...newCriteria,
      pageStart: Number(pagination.current || 1),
      pageSize: Number(pagination.pageSize || 10),
    });
  };

  const onSearch = (text: string) => {
    setCriteria({
      ...criteria,
      search: text,
      pageStart: 1,
      pageSize: 10,
    });
  };

  const onRangeChange = (dates: null | (Dayjs | null)[]) => {
    if (dates) {
      setCriteria({
        ...criteria,
        pageStart: 1,
        pageSize: 10,
        startDate: dates[0]?.toDate(),
        endDate: dates[1]?.toDate(),
      });
    } else {
      setCriteria({
        ...criteria,
        pageStart: 1,
        pageSize: 10,
        startDate: null,
        endDate: null,
      });
    }
  };

  return (
    <>
      <SubMenu active={pathSegment} items={InboundMenu} />
      <Card>
        <Title title="Good Reived" />
        <div className="flex flex-col gap-3">
          <div className="flex flex-col md:flex-row gap-3">
            <DatePicker.RangePicker
              size="large"
              locale={locale}
              onChange={onRangeChange}
            />
            <Search
              className="md:max-w-[400px] md:min-w-[400px]"
              placeholder="ค้นหา"
              allowClear
              size="large"
              enterButton="ค้นหา"
              onSearch={onSearch}
            />
          </div>
          <GoodReceiveTable
            criteria={criteria}
            goodReceive={data?.data || { data: [], totalRecords: 0 }}
            loading={isLoading || isFetching}
            onEditData={item => console.log(item)}
            onDelete={onActionInbound}
            onTableChange={onTableChange}
          />
        </div>
      </Card>
    </>
  );
};

export default GoodReceived;
